export * from "-!../../../../node_modules/.pnpm/babel-loader@8.3.0_@babel+core@7.21.8_webpack@3.12.0/node_modules/babel-loader/lib/index.js??ref--1!../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/index.js??vue-loader-options!./FooterSection.vue?vue&type=template&id=367a388e&"


//////////////////
// WEBPACK FOOTER
// ./src/components/reused-components/footer-section/FooterSection.vue?vue&type=template&id=367a388e&
// module id = 699
// module chunks = 58